/**
 * LayerWeightsRow — one group-weight stepper per layer the group applies to.
 *
 *   ⚖ Weight   Paths [70%]  Landers [30%]  Offers [50%]
 *
 * Each layer's weights are independent and sum to 100 across the groups that
 * score that layer, so a landers-only group never dilutes the paths split.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Scale } from 'lucide-react';
import type { FlowLayer } from '@trafficpulse/shared';

import { WeightStepper } from './header';

const LAYER_TITLE: Record<FlowLayer, string> = {
  paths: 'Paths',
  landers: 'Landers',
  offers: 'Offers',
};

export interface LayerWeightsRowProps {
  layers: ReadonlyArray<FlowLayer>;
  weights: Partial<Record<FlowLayer, number>>;
  onChange: (layer: FlowLayer, next: number) => void;
}

const LayerWeightsRow: FC<LayerWeightsRowProps> = ({
  layers,
  weights,
  onChange,
}) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
    <span className="flex shrink-0 items-center gap-1 text-[10.5px] font-medium uppercase tracking-wide text-muted-foreground">
      <Scale className="h-3 w-3" aria-hidden />
      Weight
    </span>
    {layers.map((layer) => (
      <span key={layer} className="flex shrink-0 items-center gap-1.5">
        <span className="text-[11px] font-medium text-muted-foreground">
          {LAYER_TITLE[layer]}
        </span>
        <WeightStepper
          weight={weights[layer] ?? 0}
          onChange={(next) => onChange(layer, next)}
        />
      </span>
    ))}
  </div>
);

export default LayerWeightsRow;
